import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { getNavItemForProductLine } from '../utils/routingUtils';
import { transformState } from './SelectorUtils';
export const navItemForProductLineSelector = createSelectorFromUtil(getNavItemForProductLine, transformState);